/**
 * Each entry represents a regular expression one can expect for an user agent.
 * Multiple entries create more speciffic conditions for Browser detection
 */
export const USER_AGENTS = [
    ['isEdge', /Edge\/([0-9\._]+)/],
    ['isChrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['isFirefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['isOpera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['isOpera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['isIE', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['isIE', /MSIE\s(7\.0)/],
    ['isIE', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['isAndroid', /Android\s([0-9\.]+)/],
    ['isSafari', /Version\/([0-9\._]+).*Safari/],
];
